<template>
    <ul class="simple-list">
        <li v-for="(item, index) in list" :key="index">
            <!-- Descrição da lista nível 1 -->
            <a @click="createLocalStorage(item.Slug)" v-if="item.Nivel == 1" :href="`${$SiteUrl}/loja/${origem}/${item.Slug}`" class="search-label-1" v-on:click.prevent="sendPage(`${$SiteUrl}/loja/${origem}/${item.Slug}`,item.Slug,item.QtdeProdutos,`${$apiUrl}`)">
                {{ item.Descricao.toUpperCase() }}
                <p class="pull-right">{{ item.QtdeProdutos }}</p>
            </a>

            <!-- Descrição da lista nível 2 -->
            <a @click="createLocalStorage(item.Slug)" :href="`${$SiteUrl}/loja/${origem}/${item.Slug}`" v-if="item.Nivel == 2" class="search-label-2" v-on:click.prevent="sendPage(`${$SiteUrl}/loja/${origem}/${item.Slug}`,item.Slug,item.QtdeProdutos,`${$apiUrl}`)">
                {{ item.Descricao.toUpperCase() }}
                <p class="pull-right">{{ item.QtdeProdutos }}</p>
            </a>

            <!-- Descrição da lista nível 3 -->
            <a @click="createLocalStorage(item.Slug)" :href="`${$SiteUrl}/loja/${origem}/${item.Slug}`" v-else-if="item.Nivel == 3" style="padding: 10px" v-on:click.prevent="sendPage(`${$SiteUrl}/loja/${origem}/${item.Slug}`,item.Slug,item.QtdeProdutos,`${$apiUrl}`)">
                {{ item.Descricao.toUpperCase() }}
                <p class="pull-right">{{ item.QtdeProdutos }}</p>
            </a>

            <!-- Itens da lista -->
            <ul v-if="item.Nivel > 3" :style="`padding-left: ${item.Nivel*10}px; padding-right: 10px`">
                <li>
                    <a @click="createLocalStorage(item.Slug)" :href="`${$SiteUrl}/loja/${origem}/${item.Slug}`" class="black-color" v-on:click.prevent="sendPage(`${$SiteUrl}/loja/${origem}/${item.Slug}`,item.Slug,item.QtdeProdutos,`${$apiUrl}`)">
                        <p class="black-color">{{ item.Descricao }}</p>
                        <p class="black-color">{{ item.QtdeProdutos }}</p>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'SimpleList',
        props: ['list', 'origem'],
        mounted() {
            if (localStorage.searchQuery === undefined) {
                localStorage.setItem('termo_pesquisa', this.$route.params.search);
            }
        },
        methods: {
            createLocalStorage: (slug) => {
                localStorage[slug] = localStorage.searchQuery;
            },
            sendPage: (url,slug, qtde,server) => {
                const api = axios.create({
                    withCredentials: true
                });
                if (qtde == 1) {
                    api.post(server + "Produto.svc/getprodutossegmentonome",
                        {
                            slug: slug
                        }).then((response) => {
                            if (response.data.length > 0) {
                                let product = {};
                                product.code = response.data[0].PRD_CODIGO + "-" + response.data[0].PRD_CODIGODV;
                                product.url = "/loja/produto/" + product.code + "/" + response.data[0].URL;
                                location.href = product.url
                            }
                            else {
                                location.href = url
                            }
                        })
                }
                else {
                    location.href = url
                }
            }
        }
    }
</script>

